import React, { useState, useEffect } from 'react';
import i18next from '../../i18n.js';
import { getWordWithCorrectEnding } from '../helpers/HelperFunctions.js';

const LeftDaysInfo = () => {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState(true);

    useEffect(() => {
        fetch('/api/account/GetVacationLimits', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then((response) => response.json())
            .then((result) => {
                if (result && result.limits) {
                    const items = [];
                    if (result.limits.unusedVacationDaysMain) {
                        items.push({
                            title: i18next.t('vacationKinds.main'),
                            value: `${result.limits.unusedVacationDaysMain} ${getWordWithCorrectEnding(result.limits.unusedVacationDaysMain, 'день')}`
                        });
                    }
                    if (result.limits.unusedVacationDaysChild) {
                        items.push({
                            title: i18next.t('vacationKinds.additionalChildcare'),
                            value: `${result.limits.unusedVacationDaysChild} ${getWordWithCorrectEnding(result.limits.unusedVacationDaysChild, 'день')}`
                        });
                    }
                    if (result.limits.unusedVacationDaysUBD) {
                        items.push({
                            title: i18next.t('vacationKinds.ubd'),
                            value: `${result.limits.unusedVacationDaysUBD} ${getWordWithCorrectEnding(result.limits.unusedVacationDaysUBD, 'день')}`
                        });
                    }
                    if (result.limits.unusedVacationDaysChaes) {
                        items.push({
                            title: i18next.t('vacationKinds.chaes'),
                            value: `${result.limits.unusedVacationDaysChaes} ${getWordWithCorrectEnding(result.limits.unusedVacationDaysChaes, 'день')}`
                        });
                    }
                    if (items.length > 0) {
                        setItems(items);
                        setLoading(false);
                    }
                }
            });

    }, []);

    return <div className='left-days-info'>
        {!loading && <div className='left-days-header'>{i18next.t('profile.leftDaysText')}</div>}
        {!loading && items && <div className='left-days-items'>
            {items.map(item => <div className='left-days-item'><div>{item.title}:</div><div>{item.value}</div></div>)}
        </div>}
    </div>
}

export default LeftDaysInfo;